import React, { useEffect, useContext, useState, useRef } from 'react';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import '../../../assets/css/buttons.css';
import { SocketContext } from '../../../context/SocketContext';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
} from '@mui/icons-material/';
import {
  TextField,
  InputAdornment,
  Select as SelectMaterial,
} from '@mui/material';
import Select, { components } from 'react-select';
import toast from 'react-hot-toast';

function ModalBankID() {
  const { t } = useTranslation();

  const inputRef = useRef(null);

  const {
    session,
    updateFocusOnMainScreen,
    updateShowModalBanUser,
    updateIsLoadingScreen,
    userInfo,
    parentInfo,

    updateIsLimitSurpassed,
    updateIsDailyLimitSurpassed,
    updateIsMonthlyLimitSurpassed,

    logoutUser,
    updateShowUserInfo,
    updatePrint,
    resetTransactions,
    updateReceiptToPrint,
    updateIsCard,
    updateIsCash,
    updateTotal,
    updatePayCard,
    updatePayCash,
    updatePaySpillerkonto,
    updateChange,
    updateCurrentUser,
    updateCurrentUserID,
    updateUserLogin,
    updatePaymentType,
    updateIsPaymentOpen,
    updateIsSellerOpen,
    updateUserInfo,
    updateIsFastUserLogin,
    updateIsAnonUser,
    updateIsHybridUser,
    updateIsFullUser,
    updateUserParent,
    updateUserChildren,
    updateUserSiblings,
    resetTicketsCH,
    updateShowModalConfirmIdentity,
    updateIsIdentityConfirmed,
    updateIsFullUserEditing,
  } = useContext(AppContext);

  const [userDisabledConfirmed, setUserDisabledConfirmed] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  useEffect(() => {
    updateFocusOnMainScreen(false);

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 900);

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const parentInfoRef = useRef(parentInfo);
  useEffect(() => {
    parentInfoRef.current = parentInfo;
  }, [parentInfo]);
  const userInfoRef = useRef(userInfo);
  useEffect(() => {
    userInfoRef.current = userInfo;
  }, [userInfo]);

  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const handleDisableUser = (data) => {
      updateIsLoadingScreen(false);
      setConfirmation(false);
      if (!data) {
        toast.error(t('error.error'));
        return;
      }
      setUserDisabledConfirmed(true);
    };
    socket.on('disableUser', handleDisableUser);

    return () => {
      socket.off('disableUser', handleDisableUser);
    };
  }, [socket]);

  const handleConfirmSentSMS = () => {
    updateShowModalBanUser(false);
  };

  const customStylesPepSelect = {
    control: (provided, state) => ({
      ...provided,
      width: '225px',
      height: '56px',
      minHeight: '58px',
      border: 'none', // Hide all borders
      boxShadow: 'none', // Remove shadow for focused state
      backgroundColor: 'transparent', // Optional: Remove background
      outline: state.isFocused ? 'none' : 'none', // Remove focus outline
      color: 'black',
      marginLeft: '-10px',
    }),
    option: (provided, { data }) => ({
      ...provided,
      borderBottom: data.isDivider ? '1px solid #ccc' : 'none',
      padding: data.isDivider ? '0' : provided.padding,
      fontSize: '1.105rem', // Smaller font size
      lineHeight: '1.2', // Adjust line height for better spacing
      backgroundColor: data.isDivider
        ? 'transparent'
        : provided.backgroundColor,
      cursor: data.isDivider ? 'default' : 'pointer',
      color: 'black',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999, // Ensure the dropdown layers above modal or other content
      color: 'black',
      border: '0.3px solid #2684FF', // Remove border from dropdown menu
      boxShadow: 'none', // Remove shadow around the dropdown
      outline: 'none', // Remove focus outline
      width: '375px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0, // Remove padding inside the dropdown
      border: 'none', // Remove inner borders
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      padding: 0, // Optional: Remove padding for compactness
    }),
    indicatorSeparator: () => ({
      display: 'none', // Hide the separator between the dropdown indicator and the input
    }),
  };

  const formatOptionLabel = ({ label, flag }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {flag && (
        <span style={{ marginRight: 8, fontSize: '1.2em' }}>{flag}</span>
      )}
      {label}
    </div>
  );

  const [reason, setReason] = useState('');
  const [reasonSelected, setReasonSelected] = useState('');

  useEffect(() => {
    console.log('Reason', reasonSelected);
  }, [reasonSelected]);

  const handleReasonChange = (selectedOption) => {
    setReason(selectedOption.value);
    setReasonSelected(selectedOption);
  };
  const reasonRef = useRef(reason);
  useEffect(() => {
    reasonRef.current = reason;
  }, [reason]);

  const [optionsReason, setOptionsReason] = useState([
    { value: 'SUSPECTED FRAUD', label: t('sales.suspectedFraud') },
    {
      value: 'MAX FAILED LOGIN ATTEMPTS',
      label: t('sales.maxFailedLoginAttempts'),
    },
    {
      value: 'Incorrect personal information',
      label: t('sales.incorrectPersonalInformation'),
    },
    { value: 'OTHER', label: t('sales.otherBanned') },
    { value: 'underaged', label: t('sales.underaged') },
    { value: 'HRL', label: t('sales.hrl') },
    { value: 'PEP', label: t('sales.pepBanned') },
    { value: 'Bad behaviour', label: t('sales.badBehaviour') },
    {
      value: 'Self exclusion for 1 month',
      label: t('sales.selfExclusionFor1Month'),
    },
    {
      value: 'Self exclusion for 3 months',
      label: t('sales.selfExclusionFor3Months'),
    },
    {
      value: 'Self exclusion for 6 months',
      label: t('sales.selfExclusionFor6Months'),
    },
    {
      value: 'Self exclusion for 1 year',
      label: t('sales.selfExclusionFor1Year'),
    },
    { value: 'Deleted account', label: t('sales.deletedAccount') },
  ]);
  const optionsReasonRef = useRef(optionsReason);
  useEffect(() => {
    optionsReasonRef.current = optionsReason;
  }, [optionsReason]);

  const [time, setTime] = useState('');
  const [timeSelected, setTimeSelected] = useState('');

  const handleTimeChange = (selectedOption) => {
    setTime(selectedOption.value);
    setTimeSelected(selectedOption);
  };
  const timeRef = useRef(time);
  useEffect(() => {
    timeRef.current = time;
  }, [time]);

  const [optionsTime, setOptionsTime] = useState([
    { value: '1 uke', label: t('sales.time1week') },
    { value: '1 måned', label: t('sales.time1month') },
    { value: '3 måneder', label: t('sales.time3months') },
    { value: '6 måneder', label: t('sales.time6months') },
    { value: '1 år', label: t('sales.time1year') },
  ]);
  const optionsTimeRef = useRef(optionsTime);
  useEffect(() => {
    optionsTimeRef.current = optionsTime;
  }, [optionsTime]);

  const handleCancel = () => {
    updateShowModalBanUser(false);
  };

  const handleConfirm = () => {
    if (!reasonSelected) {
      toast.error(t('error.errorNotOptionSelected'));
      return;
    }
    setConfirmation(true);

    //updateShowModalBanUser(false);
  };

  const handleConfirmUser = () => {
    socket.emit('disableUser', {
      session: sessionRef.current,
      userInfo: parentInfoRef.current
        ? parentInfoRef.current
        : userInfoRef.current,
      reason: reasonSelected.value,
    });
    updateIsLoadingScreen(true);
  };

  const handleCancelConfirmUser = () => {
    setConfirmation(false);
  };
  const handleConfirmUserSuccess = () => {
    setConfirmation(false);

    updateIsLimitSurpassed(false);
    updateIsDailyLimitSurpassed(false);
    updateIsMonthlyLimitSurpassed(false);

    logoutUser();
    updateShowUserInfo(false);
    updatePrint(false);
    resetTransactions();
    updateReceiptToPrint(false);
    updateIsCard(false);
    updateIsCash(false);
    updateTotal(0);
    updatePayCard(0);
    updatePayCash(0);
    updatePaySpillerkonto(0);
    updateChange(0);
    updateCurrentUser('');
    updateCurrentUserID('');
    updateUserLogin(false);
    updatePaymentType('');
    updateIsPaymentOpen(false);
    updateIsSellerOpen(false);
    logoutUser();
    updateCurrentUser('');
    updateCurrentUserID('');
    updateUserLogin(false);
    updateUserInfo({});
    updateIsFastUserLogin(false);
    updateIsAnonUser(false);
    updateIsHybridUser(false);
    updateIsFullUser(false);
    updateUserParent(false);
    updateUserChildren([]);
    updateUserSiblings([]);
    resetTicketsCH();
    updateShowModalConfirmIdentity(false);
    updateIsIdentityConfirmed(false);

    updateFocusOnMainScreen(true);
    updateIsFullUserEditing(false);
    updateShowModalBanUser(false);
  };
  return (
    <div id="react-confirm-alert">
      <div className="react-confirm-alert-overlay">
        <div className="react-confirm-alert">
          <div className="react-confirm-alert-body" style={{ width: '1000px' }}>
            <h1>{t('sales.banUserTitle')}</h1>

            {confirmation && (
              <>
                <p>{t('sales.banUserTextConfirm')}</p>
                <p>
                  <strong>{reasonSelected.label}</strong>
                </p>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleConfirmUser();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>

                  <button
                    className="btn-custom-no"
                    onClick={() => {
                      handleCancelConfirmUser();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.cancel')}
                  </button>
                </div>
              </>
            )}

            {userDisabledConfirmed && (
              <>
                <p>{t('sales.banUserTextConfirmSuccess')}</p>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleConfirmUserSuccess();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>
                </div>
              </>
            )}

            {!confirmation && !userDisabledConfirmed && (
              <>
                <p>{t('sales.banUserText')}</p>

                <div
                  style={{
                    display: 'flex',
                    gap: '16px',
                    width: '100%',
                    justifyContent: 'center',
                    alignContent: 'center',
                    alignItems: 'center',
                    margin: '20px 0 20px 0',
                    flexDirection: 'column',
                  }}
                >
                  <TextField
                    autoComplete="off"
                    label={t('sales.banUserReason') + '*'}
                    variant="outlined"
                    className="modal-textfield"
                    editable={false}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                            }}
                          >
                            <Select
                              label={t('sales.banUserReason')}
                              styles={customStylesPepSelect}
                              value={reasonSelected}
                              onChange={handleReasonChange}
                              options={optionsReason}
                              isClearable={false}
                              placeholder={
                                t('sales.banUserReasonPlaceholder') + '*'
                              }
                            />
                          </div>
                        </InputAdornment>
                      ),
                    }}
                  />

                  {false && (
                    <TextField
                      autoComplete="off"
                      label={t('sales.banUserDuration') + '*'}
                      variant="outlined"
                      className="modal-textfield"
                      editable={false}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <Select
                                label={t('sales.banUserDuration')}
                                styles={customStylesPepSelect}
                                value={timeSelected}
                                onChange={handleTimeChange}
                                options={optionsTime}
                                isClearable={false}
                                placeholder={
                                  t('sales.banUserDurationPlaceholder') + '*'
                                }
                              />
                            </div>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </div>

                <div className="react-confirm-alert-button-group">
                  <button
                    className="btn-custom-yes"
                    onClick={() => {
                      handleConfirm();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.confirm')}
                  </button>

                  <button
                    className="btn-custom-no"
                    onClick={() => {
                      handleCancel();
                    }}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px', // Space between icon and text
                    }}
                  >
                    <CancelIcon style={{ fontSize: '1.2em' }} />

                    {t('sales.cancel')}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModalBankID;
